module.exports = "/img/p4f-outline.svg?2a896bd4ee3f77bb340d769d49bc7554";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/p4f-outline.svg
// module id = CKbC
// module chunks = 70